import * as React from "react";
import { forwardRef } from "react";
const SvgToolFlipVertical = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="#726f7e" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" strokeLinecap="round" strokeWidth={1.5}><path fillRule="evenodd" clipRule="evenodd" d="M3 12.0303L21 23L21 12.0303L3 12.0303Z" fill="#CCCCCC" /><path fillRule="evenodd" clipRule="evenodd" d="M3 12.0303L21 1.06069L21 12.0303L3 12.0303Z" fill="#777777" /></g></svg>;
const ForwardRef = forwardRef(SvgToolFlipVertical);
export { ForwardRef as ReactComponent };